export default "__VITE_PUBLIC_ASSET__96c3ad09__"